import { render, staticRenderFns } from "./LivePage.vue?vue&type=template&id=5c9f0da3&"
import script from "./LivePage.vue?vue&type=script&lang=js&"
export * from "./LivePage.vue?vue&type=script&lang=js&"
import style0 from "./LivePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports